// Business Analysis tab content. Thin wrapper
// around the shared <AnalystTabContent lane="A4" /> shell.
import type { DealDetailDto } from "@/types/deals";
import { AnalystTabContent } from "./AnalystTabContent";

interface BusinessAnalysisTabContentProps {
  deal: DealDetailDto;
}

export function BusinessAnalysisTabContent({
  deal,
}: BusinessAnalysisTabContentProps) {
  return <AnalystTabContent deal={deal} lane="A4" />;
}
